export default "<router-outlet></router-outlet>\n\n<app-new-loader></app-new-loader>"